export enum Authentication
{
    None = 0,
    STARTTLS,
    SSL
}